// extracted by mini-css-extract-plugin
export default {"v-hackster":"var(--hackster)","v-standardBorderRadius":"4px","label":"ratings__label__zMgP2","checked":"ratings__checked__p6upJ"};